import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import CreditTentWrapper from "@components/layouts/creditTentWrapper";
import ServiceForm from "@components/credittent/serviceform";

const WhyUs = dynamic(() => import("@components/credittent/whyUs"));
const HowThisWork = dynamic(() => import("@components/credittent/howThisWork"));

const OffersList = dynamic(() => import("@components/shared/offersList"));
const FAQ = dynamic(() => import("@components/credittent/faq"));

import { useDomainContext } from "@hooks/useDomainContext";

export default function FreeCreditEvaluationHome(): ReactElement {
    const { domain } = useDomainContext();
    const style = {
        background: "#fff",
        borderColor: "#e3e3e3",
        buttonBackground: "#3ea636",
        buttonForground: "#fff",
    };

    return (
        <CreditTentWrapper>
            <ServiceForm />
            <section style={{ padding: "0 15px" }}>
                <OffersList offers={domain?.defaultOffers} style={style} />
            </section>
            <HowThisWork />
            <WhyUs />
            <FAQ />
        </CreditTentWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
